import { isObject } from '@tunein/web-utils';
export default function transformOpmlResponseHead(data) {
    if (!(isObject(data) && data.head)) {
        return data;
    }
    const { head, ...otherData } = data;
    const transformedHead = { ...head };
    transformedHead.status = parseInt(transformedHead.status);
    if (transformedHead.fault) {
        transformedHead.statusText = transformedHead.fault;
    }
    return { head: transformedHead, ...otherData };
}
